export default __webpack_public_path__ + "static/media/check.528a84b5.svg";